import { render } from "./honoreeVotingWrapper.vue?vue&type=template&id=3be44e7a"
import script from "./honoreeVotingWrapper.vue?vue&type=script&lang=js"
export * from "./honoreeVotingWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__